import Axios from "axios";

export async function buildApiList() {
    let tmp_apis = [];
		let tmp_apis_clean =[];

		// Fetch external API list
    await Axios.get(process.env.CDN_URL + "payloads/external-api-list.json").then(
      async function ({ data }) {
        for (let i = 0; i < data.length; i++) {
          data[i]["type"] = "external";
          tmp_apis.push(data[i]);
        }

        // Fetch internal API list
        await Axios.get(process.env.CDN_URL + "payloads/internal-api-list.json").then(
          function (response) {
            let data = response.data;
            for (let i = 0; i < data.length; i++) {
              data[i]["type"] = "internal";
              tmp_apis.push(data[i]);
            }

            // Update API list
            tmp_apis.sort(function (a, b) {
              return a.title < b.title ? -1 : a.title > b.title ? 1 : 0;
            });

            // Build cleaned up list of APIs
            let remote_img_src = server_url + "api_documentation/icons/";
            tmp_apis.forEach((api, i) => {
              let reference_link = api.documentation.referenceURL;
              let reference_text = "API Reference";
              if (api.documentation.sdkURL) {
                reference_link = api.documentation.sdkURL;
                reference_text = "SDK Reference";
              }
              let overview_url = api.documentation.guideURL;
              if (!overview_url) {
                overview_url = api.documentation.coverURL;
              }
              tmp_apis_clean.push({
                type: api.type,
                title: api.title,
                image: api.image.remote
                  ? remote_img_src + api.image.remote
                  : api.image.source,
                body: api.body,
                overviewURL: overview_url,
                referenceURL: reference_link,
                referenceText: reference_text,
                badges: api.badges ? api.badges : null
              });
            });

            // Replace "Forge" instances generated from a static JSON file:
            tmp_apis_clean = tmp_apis_clean.map(function replaceForgeWithAPS(
              api
            ) {
              const body = api.body
                    .replaceAll("Forge", "Autodesk Platform Services")
                    .replace(
                      "Autodesk Platform Services Platform",
                      "APS Platform"
                    )
                    .replace("Autodesk Platform Services Viewer", "APS Viewer")
              return { ...api, body: body };
            });
          }
        );
      }
    );
		return tmp_apis_clean;
};
